export function insertThousandsSeparator(num: number | string, separator = '\u00A0'): string {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
}